import { frontendURL } from 'dashboard/helper/URLHelper';

const CampaignsRouteView = () => import('./pages/CampaignsRouteView.vue');
const CampaignsListPage = () => import('./pages/CampaignsListPage.vue');
const CampaignNewPage = () => import('./pages/CampaignNewPage.vue');
const CampaignsSettingsPage = () => import('./pages/CampaignsSettingsPage.vue');

const meta = {
  permissions: [
    'administrator',
    'broadcast_view',
    'broadcast_create',
    'broadcast_manage',
  ],
};

const campaignsRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/campaigns'),
      component: CampaignsRouteView,
      children: [
        {
          path: '',
          name: 'campaigns_index',
          meta,
          component: CampaignsListPage,
        },
        {
          path: 'new',
          name: 'campaigns_new',
          meta,
          component: CampaignNewPage,
        },
        {
          path: 'settings',
          name: 'campaigns_settings',
          meta,
          component: CampaignsSettingsPage,
        },
      ],
    },
  ],
};

export default campaignsRoutes;
